import React, { useEffect } from "react";
import { GlobalApplicationState } from "globalApplicationState";
import { Topic } from "../models";
import { ConnectedProps, connect } from "react-redux";
import { TableCell, TableRow } from "@mui/material";
import { TagStats } from "modules/insights";
import { FormattedNumber } from "react-intl";
import { allTopicTypes, defaultTopicData } from "../models";
import TopicLeadingCell from "./topicLeadingCell";
import EmptyCheckBoxCell from "./common/emptyCheckboxCell";
import MoreTopicOptions from "./buttons/moreTopicOptions";
import Availability from "./common/availability";

const TopicRow: React.FunctionComponent<PropsWithRedux> = (props) => {
    const [topicData, setTopicData] = React.useState(defaultTopicData(props.topic));

    useEffect(() => {
        const topicStats = props.tagStats.find((tag: TagStats) => tag.id === props.topic.id);

        if (!topicStats) return setTopicData(defaultTopicData(props.topic));
        const isTypes = [props.topic.default, props.topic.mandatory, !props.topic.default && !props.topic.mandatory];

        const updatedTopicData = {
            id: props.topic.id,
            name: props.topic.name,
            restricted: props.topic.restricted,
            disabled: props.topic.disabled,
            type: allTopicTypes.filter((_, index) => isTypes[index]),
            subs: topicStats.subscriberCount,
            posts: topicStats.postCount,
            events: topicStats.eventCount,
            views: topicStats.viewCount
        };
        setTopicData(updatedTopicData);
    }, [props.tagStats, props.topic]);

    return (
        <TableRow hover>
            <EmptyCheckBoxCell />
            <TableCell align="left" padding="none"> {
                <TopicLeadingCell
                    topic={topicData}
                    checked={props.checked}
                    onCheckRow={props.onCheckRow}
                />
            } </TableCell>

            <TableCell>
                <MoreTopicOptions topic={props.topic} />
            </TableCell>

            <TableCell align="center" padding="normal"> <Availability isDisabled={topicData.disabled} /> </TableCell>
            <TableCell align="center" padding="normal"> {topicData.type.join(", ")} </TableCell>

            {
                [topicData.subs, topicData.posts, topicData.events, topicData.views].map((count, i) =>
                    <TableCell key={i} align="center" padding="normal">
                        {
                            count === "-" ? count :
                                <FormattedNumber value={count} />
                        }
                    </TableCell>
                )
            }
        </TableRow>
    );
};

interface ComponentProps {
    topic: Topic,
    checked: boolean,
    onCheckRow: (checked: boolean, topicId: string) => void;
}

const connector = connect(
    (state: GlobalApplicationState, ownProps: ComponentProps) => ({
        ...ownProps,
        tagStats: state.insights.topChannels
    })
);

type PropsWithRedux = ConnectedProps<typeof connector>;

export default connector(TopicRow);